/* eslint-disable lit-a11y/click-events-have-key-events */
// TODO: fix accessibility error

import { consume } from '@lit/context';

import { css, html, LitElement, nothing } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { classMap } from 'lit/directives/class-map.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import '../../design-system/progress/progress';
import '../../design-system/tag/tag';
import '../../design-system/timeline/timeline';
import { i18n } from '../../i18n/i18n';
import resetStyle from '../../shared/components/html-content/reset.style';
import { ludsElevation } from '../../shared/styles/elevation';
import { ENROLLMENT_STATUSES, EnrollmentStatusKeys } from '../../shared/types/common.model';
import { CoursePlayerState, stateContext } from './course-player.context';
import { COURSE_PLAYER_NAV_OPEN } from './course-player.model';
import { LudsTimeline } from '../../design-system/timeline/timeline';

@customElement('lua-course-player-sidenav')
export class LuaCoursePlayerSidenav extends LitElement {
  static override styles = [
    resetStyle,
    ludsElevation,
    css`
      :host {
        --sidenav-header-spacing-x: var(--spacing-spacing-16);
        --sidenav-header-spacing-y: var(--spacing-spacing-16);
        --sidenav-header-title-spacing-y: var(--spacing-spacing-16);
        --sidenav-border-color: var(--colours-neutrals-gray-500);
        --sidenav-border-color: var(--colours-neutrals-gray-400);
        --sidenav-header-background-color: var(--colours-neutrals-gray-100);
        --sidenav-background-color: var(--colours-neutrals-white-negative);
        --sidenav-title-color: var(--theme-link-color, --colours-brand-primary);
        --sidenav-toggle-border-color: var(--strokes-stroke-secondary);
        --sidenav-about-link-icon-color: var(--colours-extended-palette-blues-blue-900);
        --sidenav-open-width: 320px;
      }
      .sidenav {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        height: 100vh;
        max-width: var(--sidenav-open-width);
        border-right: 1px solid var(--sidenav-border-color);
        background-color: var(--sidenav-background-color);
      }

      .sidenav-header {
        display: flex;
        flex-direction: column;
        background-color: var(--sidenav-header-background-color);
        padding: var(--sidenav-header-spacing-y) var(--sidenav-header-spacing-x);
        box-sizing: border-box;
        width: var(--sidenav-open-width);
      }

      .sidenav-header-closed {
        width: 100%;
        padding: 0px;
        background-color: var(--sidenav-background-color);
        min-height: 138px;
      }

      .sidenav-header-closed .title {
        display: none;
      }

      .sidenav-header-closed .actions {
        flex-direction: column-reverse;
        align-items: center;
        margin-top: var(--spacing-spacing-12);
        gap: 4px;
      }

      .about-link {
        font-size: 11px;
        font-style: normal;
        font-weight: 400;
        line-height: 16px;
        display: flex;
        text-decoration: none;
        gap: 5px;
        color: var(--sidenav-about-link-color);
      }

      .about-link:hover {
        text-decoration: underline;
        cursor: pointer;
      }

      .about-link {
        & luds-icon {
          fill: var(--sidenav-about-link-icon-color);
        }
      }

      .sidenav-title {
        font-size: 16px;
        font-style: normal;
        font-weight: 600;
        line-height: 22px;
        margin-top: var(--sidenav-header-title-spacing-y);
        color: var(--sidenav-title-color);
        word-break: break-word;
      }

      .sidenav-title:hover {
        text-decoration: underline;
        cursor: pointer;
      }

      .sidenav-regular-text {
        color: unset;
      }
      .sidenav-regular-text:hover {
        text-decoration: none;
        cursor: none;
      }

      .sidenav-closed {
        width: auto;

        .sidenav-item {
          display: none;
        }
      }

      .nav-toggle {
        display: flex;
        width: 28px;
        height: 28px;
        position: absolute;
        align-items: center;
        justify-content: center;
        user-select: none;
        border: 1px solid var(--sidenav-toggle-border-color);
        background-color: var(--sidenav-background-color);
        border-radius: 4px;
        cursor: pointer;
        margin-left: 225px;
        margin-top: 10px;
        z-index: 2;
      }

      .nav-toggle-closed {
        margin-left: 33px;
      }

      .side-nav-message-instructor {
        margin-bottom: var(--spacing-spacing-16);
        align-self: center;
        margin-top: var(--spacing-spacing-16);
        flex-shrink: 0;
      }

      @media (max-width: 768px) {
        .sidenav {
          position: fixed;
          top: 0;
          right: 0;
          bottom: 0;
          left: 0;
          z-index: 9999;
          padding: 0;
          width: 100%;
          height: 100%;
          box-shadow: var(--luds-elevation-3);
        }

        .sidenav-message-instructor-closed {
          margin-left: var(--spacing-spacing-64);
        }

        .sidenav-closed {
          width: 0px;
        }

        .nav-toggle {
          margin-left: 190px;
        }

        .nav-toggle-closed {
          position: fixed;
          margin-left: 10px;
        }
      }

      .sidenav-item {
        display: flex;
        gap: var(--spacing-spacing-12);
      }

      .module-text {
        text-decoration: none;
        max-width: 260px;
        overflow: hidden;
        display: -webkit-box;
        text-overflow: ellipsis;
        -o-text-overflow: ellipsis;
        font-size: 14px;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        color: var(--sidenav-about-link-color);
      }

      .module-text:hover {
        text-decoration: underline;
      }

      .actions {
        width: 100%;
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
      }

      .toggle-only {
        margin-left: auto;
      }

      .actions luds-button {
        order: 2;
      }

      .side-nav-items {
        display: flex;
        flex-direction: column;
        flex: 1;
        overflow: hidden;
      }

      .sidenav-header {
        flex-shrink: 0;
      }

      .side-nav-list {
        flex: 1;
        overflow-y: auto;
        min-height: 0;
      }

      luds-timeline {
        &:hover {
          cursor: pointer;
        }
      }
    `,
  ];

  @consume({ context: stateContext, subscribe: true })
  coursePlayerState: CoursePlayerState;

  @property({ type: Number })
  progress = 0;

  private userScrolled = false;

  override updated() {
    if (this.userScrolled) return;

    this.scrollItemIntoView();
  }

  // Add a one-time scroll event listener to set userScrolled to true
  override firstUpdated() {
    const scrollContainer = this.renderRoot.querySelector('.side-nav-list');

    scrollContainer?.addEventListener(
      'scroll',
      () => {
        this.userScrolled = true;
      },
      { once: true }
    );
  }

  private scrollItemIntoView() {
    const navItemsList = [...this.renderRoot.querySelectorAll<LudsTimeline>('luds-timeline')];
    const activeNavItem = navItemsList.find((item) => item.active);

    if (activeNavItem) {
      activeNavItem.scrollIntoView({
        block: 'start',
        behavior: 'instant',
      });
    }
  }

  private toggleSideNav(e: Event) {
    e.preventDefault();
    e.stopPropagation();
    this.coursePlayerState.toggleSidenav();
  }

  private moduleClickHandler(moduleId: number) {
    return (e: Event) => {
      e.preventDefault();
      e.stopPropagation();
      this.coursePlayerState.navigateToModule(moduleId);
    };
  }

  private navigateToContentDetails() {
    const { isPreview, navigateToContentDetails, navigateBackToCourse } = this.coursePlayerState;

    if (isPreview) {
      navigateBackToCourse();
      return;
    }

    navigateToContentDetails();
  }

  private exitCourse() {
    this.coursePlayerState.exitCourse();
  }

  private convertModuleStatus(status: ENROLLMENT_STATUSES): EnrollmentStatusKeys {
    const statusNumber = Number(status);
    if (statusNumber in ENROLLMENT_STATUSES) {
      return ENROLLMENT_STATUSES[`${statusNumber}`] as EnrollmentStatusKeys;
    }

    throw new Error(`Invalid status: ${status}`);
  }

  private getProgressBarStatus() {
    const enrollment = this.coursePlayerState.enrollment;

    if (enrollment?.status_id == ENROLLMENT_STATUSES.PASSED) {
      return 'success';
    }

    if (enrollment?.status_id == ENROLLMENT_STATUSES.FAILED && enrollment.show_passfail_to_learners == 1) {
      return 'error';
    }

    return 'success';
  }

  override render() {
    const isSidenavOpen = localStorage.getItem(COURSE_PLAYER_NAV_OPEN);
    if (isSidenavOpen !== null) {
      this.coursePlayerState.isSidenavOpen = JSON.parse(isSidenavOpen);
    }
    const toggleOnly = {
      'toggle-only': this.coursePlayerState.isSidenavOpen && !this.coursePlayerState.showExitCourseButton,
    };

    const sideNavClosed = { 'sidenav-closed': !this.coursePlayerState.isSidenavOpen };
    const sideNavMessageInstructorClosed = {
      'sidenav-message-instructor-closed': !this.coursePlayerState.isSidenavOpen,
    };
    const headerClosed = { 'sidenav-header-closed': !this.coursePlayerState.isSidenavOpen };
    const { percentage_complete, name } = this.coursePlayerState?.enrollment || {};
    const percentageComplete = Number(percentage_complete ?? 0);
    const isCourseCompleted =
      percentageComplete === 100 &&
      [ENROLLMENT_STATUSES.COMPLETED, ENROLLMENT_STATUSES.PASSED].includes(
        this.coursePlayerState?.enrollment.status_id
      );
    const progressLabel = isCourseCompleted ? i18n('lua.courses.complete_success') : `${percentageComplete}%`;

    const DEFAULT_ICON = 'checkmark';

    const modules = this.coursePlayerState.courseStructure.map((module) => {
      const status = this.convertModuleStatus(module.enrollment_component_status_id);

      const iconByStatus: Partial<Record<EnrollmentStatusKeys, string>> = {
        PENDING_REVIEW: 'time',
        FAILED: 'clear',
      };

      return {
        id: module.id,
        content: module.title,
        status: module.enrollment_component_status_id,
        icon: status in iconByStatus ? iconByStatus[`${status}`] : DEFAULT_ICON,
        sequenced: Boolean(this.coursePlayerState.enrollment.enable_sequencing),
        enrollment: module.enrollment_status_id === 'pending' ? 'pending' : undefined,
        active: module.id === this.coursePlayerState.currentModule?.id,
      };
    });

    const canMessageInstructor =
      !this.coursePlayerState.enrollment?.disable_message_author &&
      !this.coursePlayerState.settings.disable_messaging &&
      !this.coursePlayerState.enrollment?.license_id;

    return html`
      <aside class="sidenav ${classMap(sideNavClosed)}">
        <div class="side-nav-items">
          <div class="sidenav-header ${classMap(headerClosed)}">
            <div class="actions">
              ${this.coursePlayerState.showExitCourseButton
                ? html` <luds-button
                    text="${this.coursePlayerState.isSidenavOpen ? i18n('lua.exit_course_player') : ''}"
                    variant="ghost"
                    aria-label="${i18n('lua.exit_course_player')}"
                    size="small"
                    icon="arrow_left"
                    data-qa-id="Exit"
                    @click="${this.exitCourse}"></luds-button>`
                : nothing}

              <luds-button
                class="${classMap(toggleOnly)}"
                variant="ghost"
                size="small"
                icon="sidebar"
                aria-label=${i18n('lua.a11y.toggle_side_navigation')}
                @click="${this.toggleSideNav}"></luds-button>

              ${!this.coursePlayerState.isSidenavOpen ? html`<span> ${percentageComplete}% </span>` : nothing}
            </div>

            <span class="title">
              <h3
                @click="${this.coursePlayerState.showExitCourseButton ? this.navigateToContentDetails : undefined}"
                class="sidenav-title ${classMap({
                  'sidenav-regular-text': !this.coursePlayerState.showExitCourseButton,
                })}"
                role="${ifDefined(this.coursePlayerState.showExitCourseButton ? undefined : 'link')}">
                ${name}
              </h3>
              <luds-progress
                .value="${percentageComplete}"
                label="${progressLabel}"
                .showIcon="${isCourseCompleted}"
                size="small"
                .variant="${this.getProgressBarStatus()}"></luds-progress>
            </span>
          </div>

          <nav class="side-nav-list">
            ${modules.map(
              (event, index) => html`
                <luds-timeline
                  .timelineTitle="${event.content}"
                  .sequenced="${event.sequenced}"
                  .status="${event.status}"
                  .icon="${event.icon ?? DEFAULT_ICON}"
                  .active="${event.active}"
                  .timestamp="${this.coursePlayerState.timestamp}"
                  .customClass="${index === 0 ? 'first' : index === modules.length - 1 ? 'last' : ''}"
                  @click="${this.moduleClickHandler(event.id)}">
                  <div class="sidenav-item">
                    <a href="#" @click="${this.moduleClickHandler(event.id)}" class="module-text">${event.content}</a>
                    ${event.enrollment === 'pending'
                      ? html` <luds-tag
                          type="progress"
                          size="small"
                          content="${i18n('lua.enrollment_status.pending')}"></luds-tag>`
                      : nothing}
                  </div>
                </luds-timeline>
              `
            )}
          </nav>
        </div>
        ${canMessageInstructor
          ? html`<luds-button
              text="${this.coursePlayerState.isSidenavOpen ? i18n('lua.message_instructor.message_instructor') : ''}"
              class="side-nav-message-instructor ${classMap(sideNavMessageInstructorClosed)}"
              variant="secondary"
              size="${this.coursePlayerState.isSidenavOpen ? 'small' : 'large'}"
              icon="messages"
              @click="${() => this.coursePlayerState.toggleInstructorMessage(true)}">
            </luds-button>`
          : nothing}
      </aside>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'lua-course-player-sidenav': LuaCoursePlayerSidenav;
  }
}
